export enum UserType {
    PlatoUser = 'PlatoUser',
    SuperAdmin = 'SuperAdmin',
    NoAccount = 'NoAccount',
}
